$(function () {
     

    resize();
    $(window).resize(function (event) {
        resize();
    });
    font();
    $(".modal_cont .close").click(function () { $(this).parents(".modal").stop().fadeOut() })
    $(".ul_tag li").click(function () { 
        var $li = $(this);
        var checkboxId = $li.data('checkbox');
        if (checkboxId) {
            var $checkbox = $('#' + checkboxId);
            $checkbox.prop('checked', !$checkbox.prop('checked'));
        }
        $(this).toggleClass("on"); 
    })
     
    document.body.addEventListener('touchstart', function () { });
    var swiper1 = new Swiper('#headerSwiper', {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        loop: true,
        navigation: {
            nextEl: '.header_swiper_prev',
            prevEl: '.header_swiper_next',
        },
    });
    
    // 将Swiper实例保存到全局变量以便访问
    window.swiperInstances = {
        swiper1: swiper1, 
    };
      
});

/*main*/
//

function font() {
    var sw = $("body,html").width();
    var pw = 3840;
    if ($("body,html").width() > 1366) pw = 3840
    if ($("body,html").width() < 1366 && $("body,html").width() > 1024) pw = 2880
    if ($("body,html").width() < 1024 && $("body,html").width() > 767) pw = 1920
    if ($("body,html").width() < 767) pw = 2880
    var f = 100 * sw / pw;
    $('html').css('font-size', f + 'px');
}


/*call*/
//
function resize() {
    var ht = $(window).height();
    font();
} 